<p-toast key="selectionEtapes"></p-toast>

@if (!EstCharge()) {
    <p-card>
        <div class="fluid formgrid grid">
            <div class="flex flex-column gap-2 my-2 col-12 text-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
    </p-card>
}

@if (EstCharge()) {
    <div class="flex flex-column gap-3">
        <p-card>
            <p-tabView [scrollable]="true" orientation="left">
                <p-tabPanel [header]="'Préventifs (' + entretiensPreventifs.length + ')'" leftIcon="pi pi-shield">
                    <div class="col-12 p-0">
                        <p-table #dt [value]="entretiensPreventifs" dataKey="entretienPreventifId" autoLayout="true"
                            tableStyleClass="tableNormale" [(selection)]="selectionentretiensPreventifs"
                            styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [rows]="10"
                            [paginator]="true" [filterDelay]="0" [globalFilterFields]="['description']"
                            scrollHeight="35vh">
                            <ng-template pTemplate="caption">
                                <span class="p-input-icon-left w-full md:w-auto">
                                    <i class="pi pi-search"></i>
                                    <input #rechercheItem pInputText type="text" class="w-full md:w-20rem"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        (keyup.enter)="surEntreeRecherchePreventifs()"
                                        placeholder="Recherche..." />
                                </span>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th rowspan="2" style="min-width: 3rem">
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th rowspan="2" pSortableColumn="description">
                                        <div class="flex justify-content-between align-items-center">
                                            Description
                                            <p-sortIcon field="description"></p-sortIcon>
                                            <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                            </p-columnFilter>
                                        </div>
                                    </th>
                                    <th rowspan="2" pSortableColumn="etat">
                                        <div class="flex justify-content-between align-items-center">
                                            État
                                            <p-sortIcon field="etat"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th colspan="3">Heures</th>
                                    <th colspan="3">KMs</th>
                                    <th colspan="3">Mois</th>
                                </tr>
                                <tr>
                                    <th pSortableColumn="heuresFait">
                                        <div class="flex justify-content-between align-items-center">
                                            Fait
                                            <p-sortIcon field="heuresFait"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresDu">
                                        <div class="flex justify-content-between align-items-center">
                                            Dû
                                            <p-sortIcon field="heuresDu"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresEcart">
                                        <div class="flex justify-content-between align-items-center">
                                            Écart
                                            <p-sortIcon field="heuresEcart"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresFait">
                                        <div class="flex justify-content-between align-items-center">
                                            Fait
                                            <p-sortIcon field="heuresFait"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresDu">
                                        <div class="flex justify-content-between align-items-center">
                                            Dû
                                            <p-sortIcon field="heuresDu"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresEcart">
                                        <div class="flex justify-content-between align-items-center">
                                            Écart
                                            <p-sortIcon field="heuresEcart"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresFait">
                                        <div class="flex justify-content-between align-items-center">
                                            Fait
                                            <p-sortIcon field="heuresFait"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresDu">
                                        <div class="flex justify-content-between align-items-center">
                                            Dû
                                            <p-sortIcon field="heuresDu"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="heuresEcart">
                                        <div class="flex justify-content-between align-items-center">
                                            Écart
                                            <p-sortIcon field="heuresEcart"></p-sortIcon>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-preventif>
                                <tr [pContextMenuRow]="preventif">
                                    <td>
                                        <p-tableCheckbox [value]="preventif"></p-tableCheckbox>
                                    </td>
                                    <td>{{preventif.description}}</td>
                                    <td>
                                        <span [class]="'statut ' + preventif.statut.nom.toLowerCase().replace(' ','')">
                                            {{preventif.statut.nom}}
                                        </span>
                                    </td>
                                    <td>{{preventif.heureFait}}</td>
                                    <td>{{preventif.heureDu}}</td>
                                    <td>{{preventif.heureEcart}}</td>
                                    <td>{{preventif.kmFait}}</td>
                                    <td>{{preventif.kmDu}}</td>
                                    <td>{{preventif.kmEcart}}</td>
                                    <td>{{preventif.moisFait | date:'yyyy-MM-dd'}}</td>
                                    <td>{{preventif.moisDu | date:'yyyy-MM-dd'}}</td>
                                    <td>{{preventif.moisEcart}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="12">Aucun entretien préventif.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>

                <p-tabPanel [header]="'Correctifs (' + entretiensCorrectifs.length + ')'" leftIcon="pi pi-briefcase">
                    <div class="col-12 p-0">
                        <p-table #dtCorrectifs [value]="entretiensCorrectifs" dataKey="entretienCorrectifId"
                            autoLayout="true" tableStyleClass="tableNormale" [(selection)]="selectionentretiensCorrectifs"
                            (onRowSelect)="surSelectionEntretiensCorrectifs($event)"
                            (onRowUnselect)="surDeselectionEntretiensCorrectifs($event)"
                            styleClass="p-datatable-sm" [rowHover]="true" [rows]="10" [paginator]="true"
                            [filterDelay]="0" [globalFilterFields]="['description']" scrollHeight="35vh">
                            <ng-template pTemplate="caption">
                                <div class="flex align-items-center gap-2 flex-wrap">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="dtCorrectifs.filterGlobal($event.target.value, 'contains')"
                                            (keyup.enter)="surEntreeRechercheCorrectifs()"
                                            placeholder="Recherche..." />
                                    </span>
                                    @if (estAutorise('entretien_correctif_creer') || estAutorise('temp_mec')) {
                                        <p-button icon="pi pi-plus" severity="success" [rounded]="true"
                                            pTooltip="Ajouter un entretien correctif" tooltipPosition="top"
                                            (onClick)="nouveauEntretienCorrectif()"></p-button>
                                    }
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="min-width: 3rem; width: 3rem;">
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th pSortableColumn="etat">
                                        <div class="flex justify-content-between align-items-center">
                                            Sévérité
                                            <p-sortIcon field="etat"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="description">
                                        <div class="flex justify-content-between align-items-center">
                                            Description
                                            <p-sortIcon field="description"></p-sortIcon>
                                            <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                                            </p-columnFilter>
                                        </div>
                                    </th>
                                    <th pSortableColumn="note">
                                        <div class="flex justify-content-between align-items-center">
                                            Note
                                            <p-sortIcon field="note"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="employe.nom">
                                        <div class="flex justify-content-between align-items-center">
                                            Saisi par
                                            <p-sortIcon field="employe.nom"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="date">
                                        <div class="flex justify-content-between align-items-center">
                                            Date
                                            <p-sortIcon field="dateCreation"></p-sortIcon>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-correctif>
                                <tr [pContextMenuRow]="correctif">
                                    <td>
                                        <p-tableCheckbox [value]="correctif"></p-tableCheckbox>
                                    </td>
                                    <td>
                                        <span [class]="'severite ' + correctif.severite.nom.toLowerCase().replace(' ', '')">
                                            {{correctif.severite.nom}}
                                        </span>
                                    </td>
                                    <td>{{correctif.description}}</td>
                                    <td>{{correctif.note}}</td>
                                    <td><app-employe-avec-emplacement [employe]="correctif.employe"></app-employe-avec-emplacement></td>
                                    <td>{{correctif.dateCreation | date:'yyyy-MM-dd'}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6">Aucun entretien correctif.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>

                <p-tabPanel [header]="'Manuel (' + etapesManuel.length + ')'" leftIcon="pi pi-pencil">
                    <p-table [value]="filtrerEtapesManuel()" dataKey="idTemporaire" autoLayout="true"
                        tableStyleClass="tableNormale" styleClass="p-datatable-sm p-datatable-striped"
                        [rowHover]="true" scrollHeight="25vh">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center gap-2 flex-wrap">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" class="w-full md:w-20rem" [(ngModel)]="filtreManuel"
                                        placeholder="Recherche..." />
                                </span>
                                <p-button icon="pi pi-plus" severity="success" [rounded]="true"
                                    pTooltip="Ajouter une étape manuelle" tooltipPosition="top"
                                    (onClick)="ouvrirEtapeManuelle()"></p-button>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Description</th>
                                <th>Catégorie</th>
                                <th>Note</th>
                                <th style="width: 7rem;"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-etapeManuel>
                            <tr>
                                <td>{{etapeManuel.description}}</td>
                                <td>{{etapeManuel.categorie | categorieEntretien}}</td>
                                <td>{{etapeManuel.note}}</td>
                                <td>
                                    <div class="flex gap-1">
                                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true"
                                            pTooltip="Modifier" tooltipPosition="top"
                                            (onClick)="modifierEtapeManuel(etapeManuel)"></p-button>
                                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [text]="true"
                                            pTooltip="Supprimer" tooltipPosition="top"
                                            (onClick)="supprimerEtapeManuel(etapeManuel)"></p-button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="4">Aucune étape manuelle.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabPanel>

                <p-tabPanel header="Liste de vérification" leftIcon="pi pi-list">
                    <div class="col-12 p-0">
                        <p-table #dtListe [value]="listesVerification" dataKey="listeVerificationId" autoLayout="true"
                            tableStyleClass="tableNormale" [(selection)]="selectionListesVerification"
                            styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [rows]="10"
                            [paginator]="true" [filterDelay]="0" [globalFilterFields]="['nom','description']"
                            scrollHeight="35vh">
                            <ng-template pTemplate="caption">
                                <span class="p-input-icon-left w-full md:w-auto">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="dtListe.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Recherche..." />
                                </span>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="min-width: 3rem; width: 3rem;">
                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th pSortableColumn="nom">
                                        <div class="flex justify-content-between align-items-center">
                                            Nom
                                            <p-sortIcon field="nom"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="description">
                                        <div class="flex justify-content-between align-items-center">
                                            Description
                                            <p-sortIcon field="description"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="nbPoints">
                                        <div class="flex justify-content-between align-items-center">
                                            Nb points
                                            <p-sortIcon field="nbPoints"></p-sortIcon>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-listeVerif>
                                <tr [pContextMenuRow]="listeVerif">
                                    <td>
                                        <p-tableCheckbox [value]="listeVerif"></p-tableCheckbox>
                                    </td>
                                    <td>{{listeVerif.nom}}</td>
                                    <td>{{listeVerif.description}}</td>
                                    <td>{{listeVerif.nbPoints}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="4">Aucune liste de vérification.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </p-card>

        <p-card>
            <ng-template pTemplate="title">
                <span class="text-lg font-medium">Informations par défaut des étapes</span>
            </ng-template>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <label for="mecanicien" class="block mb-2">Fait par</label>
                    <p-dropdown inputId="mecanicien" [options]="employes" [(ngModel)]="mecanicien" optionLabel="initiales"
                        [showClear]="true" filter="true" filterBy="prenomNom,prenom,nom,initiales,noEmploye" appendTo="body"
                        placeholder="Sélectionner un employé..."
                        (ngModelChange)="surChoixMecanicien($event)">
                        <ng-template pTemplate="selectedItem">
                            @if (mecanicien) {
                                <div>{{mecanicien.prenom}} {{mecanicien.nom}}</div>
                            }
                        </ng-template>
                        <ng-template let-employe pTemplate="item">
                            <div>{{employe.prenom}} {{employe.nom}}</div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-12 md:col-6 flex align-items-end">
                    <div class="flex align-items-center gap-2 pb-2">
                        <p-checkbox inputId="indComplete" [(ngModel)]="indComplete" [binary]="true"></p-checkbox>
                        <label for="indComplete" class="mb-0 cursor-pointer">Fait?</label>
                    </div>
                </div>
            </div>
        </p-card>

        <div class="flex justify-content-end gap-2 pt-2 border-top-1 surface-border selection-etapes-footer">
            <p-button label="Annuler" icon="pi pi-ban" severity="secondary" [text]="true"
                (onClick)="annuler()"></p-button>
            <p-button label="Ajouter" icon="pi pi-check" [disabled]="!estSelectionValide()"
                (onClick)="surSelection()"></p-button>
        </div>
    </div>
}
